var _rect, _rect2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 1024,
    height: 1024,
    role: "img",
    "aria-label": "Dreamcode",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 224,
    fill: "#fb7185"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 140,
    width: 744,
    height: 744,
    rx: 96,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 24
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 512,
    y: 530,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
    fontSize: 340,
    fontWeight: 700,
    fill: "#ffffff",
    letterSpacing: -12
  }, "DC")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a6a7343230d7e3f66ff9843c24931909.svg";
export { ForwardRef as ReactComponent };